import type { QuestDifficulty, QuestStatus, UserRole } from '@aegislab/shared';
import { brightTokens } from '../ui/tokens/orv-quest.tokens';

/** 퀘스트/월드 퀘스트 탭 네비게이션 (아이콘은 페이지에서 추가) */
export const questTabs = [
  { id: 'quests', label: '퀘스트', accentColor: brightTokens.primary.default },
  { id: 'world-quests', label: '월드 퀘스트', accentColor: brightTokens.secondary.default },
];

/** 퀘스트 상태 라벨 */
export const statusLabels: Record<
  'pending' | 'in_progress' | 'locked' | 'completed' | 'failed' | 'withdrawn' | 'archived',
  string
> = {
  pending: '대기중',
  in_progress: '진행중',
  locked: '분배 완료',
  completed: '완료',
  failed: '실패',
  withdrawn: '철회',
  archived: '보관됨',
};

/** QuestStatus(shared enum) 한글 라벨 — statusLabels 어휘와 정합 (entities/quest mapQuestToListItem 매핑 기준) */
export const QUEST_STATUS_LABELS: Record<QuestStatus, string> = {
  DRAFT: '대기중',
  ACTIVE: '진행중',
  LOCKED: '분배 완료',
  COMPLETED: '완료',
  FAILED: '실패',
  WITHDRAWN: '철회',
  ARCHIVED: '보관됨',
};

/** QuestDifficulty(shared enum) 한글 라벨 — company-settings DIFFICULTY_LABELS 어휘 재사용 */
export const QUEST_DIFFICULTY_LABELS: Record<QuestDifficulty, string> = {
  COMMON: '간단',
  UNCOMMON: '보통',
  RARE: '도전',
  EPIC: '고난도',
  LEGENDARY: '특별',
};

/** 팀 색상 팔레트 (인덱스 순환) */
export const TEAM_COLORS = [
  '#EF4444', // red
  '#3B82F6', // blue
  '#22C55E', // green
  '#F59E0B', // amber
  '#A855F7', // purple
  '#06B6D4', // cyan
  '#EC4899', // pink
  '#F97316', // orange
] as const;

export function getTeamColor(index: number): string {
  return TEAM_COLORS[index % TEAM_COLORS.length] as string;
}

/** 역할 라벨 */
export const roleLabels: Record<UserRole, string> = {
  ADMIN: '관리자',
  OPERATOR: '운영자',
  PLAYER: '플레이어',
};

/** 참가자 수 기준 열기(heat) 임계값 */
export const HEAT_THRESHOLDS = {
  warm: 5,
  hot: 20,
  blazing: 50,
} as const;
